<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import Headers from "./table_headers";
import appConfig from "@/app.config";
import axios from "@/axios"
import {getDateWithFormat} from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import Filter from "../../../components/filters/Filter";

export default {
  page: {
    title: "UnidadesNuevas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    "export-button": ExportButton,
    "filters": Filter
  },
  data(){
    return {
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      tableData: [],
      fields: Headers.unidades,
      valuePagination: {
        default: 1,
      },
      title: "Unidades nuevas",
      daterange: [new Date("2000-01-01"), new Date()],
      rutEmpresa: "",
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filtros: ['rut', 'date'],
      filtersValue: {
        rutEmpresa: ""
      },
      sortBy: "numeroSolicitud",
      sortDesc: true,
      totRegistros: 16,
      buttonClicked: undefined,
      pdf: "",
      dataExport: []
    }
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getSolicitud() {
      if(this.filtersValue.rutEmpresa){
        let path = `/VehiculosPreparacion?RutEmpresa=${this.filtersValue.rutEmpresa}` +
        `&Pagina=${this.currentPage}` +
        `&Registros=${this.perPage}`
        ;
        this.isBusy = true;
        axios
            .get(path)
            .then((solicitud) => {
              this.tableData = solicitud.data.datos;
              this.totRegistros = solicitud.data.totalRegistros;
              this.isBusy = false;
              this.getToExport()
            })
            .catch((error) => {
              if (error.response) {
                this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                  title: this.$t("NoData.error.title").toString(),
                  variant: "danger",
                  solid: true,
                });
              }
              this.isBusy = false;
            });
      }      
    },
    getToExport() {
      axios
        .get(`/VehiculosPreparacion?RutEmpresa=${this.filtersValue.rutEmpresa}&Pagina=1&Registros=${this.totRegistros}`)
          .then((solicitud) => {
            this.dataExport = solicitud.data.datos;
          })
    },
    downloadDocumento(row){
      this.buttonClicked = row.item.numeroSolicitud;
      axios
        .get(`/DescargarEquipamiento?numeroSolicitud=${this.buttonClicked}`)
        .then((doc) => {
          this.pdf = doc.data.pdf;
        })
        .catch(() => {
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
                title: this.$t('lease.pdf.error.download').toString(),
                variant: 'danger',
                solid: true
            });
            this.buttonClicked = undefined;
        });
      if(this.pdf){
        const blob = this.b64toBlob(this.pdf, "application/pdf");
        let fileURL = window.URL.createObjectURL(blob);
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `${row.item.numeroSolicitud}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }      
      this.buttonClicked = undefined;
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, {type: contentType});
    }
  },
  watch:{
    currentPage(){
      this.getSolicitud();
    }
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Unidades nuevas en preparación</h4>
              <export-button :data="dataExport" fileName="UnidadesNuevas" />
            </b-row>
            <filters
                :filtros="filtros"
                :value="filtersValue"
                @change="getSolicitud"
            />
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0 mt-3">
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :busy="isBusy"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <!-- Rows compartidos -->
<!--                <template #cell(nroSiniestro)="row">-->
                  <!--                  <router-link-->
                  <!--                      :to="'/siniestros/siniestro-detail/' + row.value"-->
                  <!--                      target="_blank">-->
                  <!--                    {{row.value}}-->
                  <!--                  </router-link>-->
<!--                  <router-link-->
<!--                      :to="'/'">-->
<!--                    {{row.value}}-->
<!--                  </router-link>-->
<!--                </template>-->
                <template #empty="">
                    <h5 style="text-align: center">
                    {{ $t("request.table.empty") }}
                    </h5>
                </template>
                <template #cell(fechaSolicitud)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(descarga)="row">
                  <div class="text-center">
                    <b-button variant="danger" @click="downloadDocumento(row)">
                      <i v-if="buttonClicked !== row.item.marca" class="bx bx-download font-size-16 align-middle" />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      Descargar
                    </b-button>
                  </div>
                </template>
              </b-table>
              <!-- Fin Tabla -->
              <!-- Inicio Paginación -->
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination
                    @page-click="changePage"-->
                    <b-pagination
                        class="portal"
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="totRegistros"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
              <!-- Fin Paginación -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>

</style>
